import { render, staticRenderFns } from "./UserCreateEdit.vue?vue&type=template&id=3752615e"
import script from "./UserCreateEdit.vue?vue&type=script&lang=js"
export * from "./UserCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports